import $ from 'jquery';
window.$ = window.jQuery = $;
import {slideUp, slideDown} from 'es6-slide-up-down';

import stickyNav from "./components/sticky-nav";
import accordion from "./components/accordion";
import glightbox from "./components/glightbox";
import slick from "./components/slick";
import togglePassword from "./components/toggle-password";

document.addEventListener("DOMContentLoaded", () => {
    stickyNav();
    accordion(slideUp, slideDown);
    glightbox();
    slick();
    togglePassword();
});
